/**
 * AlertsNotification.jsx
 * Created by michaelbray on 2/13/18.
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as alertLevels from '../../../helpers/alertLevelsHelper';
import AlertsByLevel from './AlertsByLevel';

function getLocationParams(location) {
    if (location.pathname) {
        const paths = location.pathname.split('/');

        if (paths.length > 2) {
            // For tours, /ticket/facility/tour/{id}
            if (paths[1] === 'ticket' && paths.length > 4) {
                return { location_id: paths[4], location_type: 'Ticket Facility' };
            }

            // For ticket facilities, /ticket/facility/{id}
            if (paths[1] === 'ticket' && paths.length > 3) {
                return { location_id: paths[3], location_type: 'Ticket Facility' };
            }

            // For camping, /camping/campground/{id}
            if (paths[1] === 'camping' && paths.length > 3) {
                return { location_id: paths[3], location_type: 'Campground' };
            }

            // For vehicle permits, /vehiclepermits/{id}
            if (paths[1] === 'vehiclepermits' && paths.length > 2) {
                return { location_id: paths[2], location_type: 'Vehicle Permit' };
            }

            // For permits, /permits/{id}
            return { location_id: paths[2], location_type: 'Permit' };
        }
    }

    return null;
}


export default function AlertsNotification({ alerts, fetchAlerts, autoFetchForLocationChange }) {
    const location = useLocation();

    useEffect(() => {
        if (autoFetchForLocationChange) {
            const locationParams = getLocationParams(location);
            fetchAlerts(locationParams);
        }
    }, [location]);

    if (!alerts || alerts.length === 0) {
        return null;
    }

    const infoAlerts = alerts.filter((a) => a.alert_level === alertLevels.INFO_ALERT_LEVEL);
    const warningAlerts = alerts.filter((a) => a.alert_level === alertLevels.WARNING_ALERT_LEVEL);
    const successAlerts = alerts.filter((a) => a.alert_level === alertLevels.SUCCESS_ALERT_LEVEL);
    const errorAlerts = alerts.filter((a) => a.alert_level === alertLevels.ERROR_ALERT_LEVEL);

    return (
        <div className="nav-header-alerts" role="complementary" aria-label="Site alert">
            <AlertsByLevel alerts={errorAlerts} level={alertLevels.ERROR_ALERT_LEVEL} />
            <AlertsByLevel alerts={warningAlerts} level={alertLevels.WARNING_ALERT_LEVEL} />
            <AlertsByLevel alerts={infoAlerts} level={alertLevels.INFO_ALERT_LEVEL} />
            <AlertsByLevel alerts={successAlerts} level={alertLevels.SUCCESS_ALERT_LEVEL} />
        </div>
    );
}

AlertsNotification.propTypes = {
    alerts: PropTypes.array,
    fetchAlerts: PropTypes.func,
    autoFetchForLocationChange: PropTypes.bool
};

AlertsNotification.defaultProps = {
    alerts: [],
    fetchAlerts: () => true,
    autoFetchForLocationChange: false
};
